/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=332da177"
const script = {}

import "./App.vue?vue&type=style&index=0&id=332da177&lang=less"

import exportComponent from "/Users/qudong/Desktop/work/github/vue3-vant3-h5-template-ts/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.72.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__